import * as lib from '~/dependencies';

export const StrengthContainer = lib.styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
`;

export const StrengthBar = lib.styled.div`
    width: 80px;
    height: 5px;
    border-radius: 5px;
    background-color: ${(props: { color?: string }) =>
      props.color ? props.color : '#e0e0e0'};
    transition: background-color 0.3s ease;
`;
